module.exports = __webpack_public_path__ + "img/COMO_02.adb23bdf.jpg";